module.exports = __webpack_public_path__ + "static/media/logo_indus.ab0568e2.png";